import React from 'react';
import TalkToExpert from '../../components/TalkToExpert';
import '../ServicePage.css';

const DataRecovery = () => {
  return (
    <div className="service-page">
      <div className="service-hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="service-title">Data Recovery Services</h1>
            <p className="service-description">
              Professional data recovery services to retrieve lost or corrupted data 
              from various storage devices with high success rates.
            </p>
          </div>
        </div>
      </div>

      <div className="service-content">
        <div className="container">
          <div className="content-grid">
            <div className="service-details">
              <h2>Data Recovery Solutions</h2>
              
              <div className="service-features">
                <div className="feature-item">
                  <div className="feature-header">
                    <div className="feature-icon">💾</div>
                    <h3>Hard Drive Recovery</h3>
                  </div>
                  <p>Recovery from failed, corrupted, or physically damaged hard drives and SSDs.</p>
                  <div className="feature-popover">
                    <div className="popover-title">Hard Drive Recovery</div>
                    <ul className="popover-list">
                      <li>Logical/physical failure diagnostics</li>
                      <li>Clean‑room head/platter work (as applicable)</li>
                      <li>Firmware, translator and module repair</li>
                      <li>SSD controller and NAND handling</li>
                      <li>Imaging, cloning and sector‑level reads</li>
                      <li>File system rebuild and verification</li>
                    </ul>
                  </div>
                </div>
                
                <div className="feature-item">
                  <div className="feature-header">
                    <div className="feature-icon">📼</div>
                    <h3>Media Recovery</h3>
                  </div>
                  <p>Recovery of photos, videos, and documents from various memory cards and USB drives.</p>
                  <div className="feature-popover">
                    <div className="popover-title">Media Recovery</div>
                    <ul className="popover-list">
                      <li>SD/microSD, CF and USB drive recovery</li>
                      <li>Camera RAW photo and 4K video restoration</li>
                      <li>Corrupt partition and lost volume repair</li>
                      <li>Accidental deletion and quick‑format cases</li>
                      <li>File carving and integrity verification</li>
                      <li>Encrypted media support (where keys available)</li>
                    </ul>
                  </div>
                </div>
                
                <div className="feature-item">
                  <div className="feature-header">
                    <div className="feature-icon">📊</div>
                    <h3>Database Recovery</h3>
                  </div>
                  <p>Specialized recovery services for corrupted databases and enterprise applications.</p>
                  <div className="feature-popover">
                    <div className="popover-title">Database Recovery</div>
                    <ul className="popover-list">
                      <li>SQL Server, MySQL/MariaDB, PostgreSQL</li>
                      <li>Corruption repair and transaction log replay</li>
                      <li>Schema rebuild and index reconstruction</li>
                      <li>Point‑in‑time recovery and roll‑forward</li>
                      <li>RPO/RTO planning and validation</li>
                      <li>Export and integrity checks</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="benefits-section">
                <h2>Why Choose Our Recovery Services?</h2>
                <ul className="benefits-list">
                  <li>✓ 85-95% successful recovery rate</li>
                  <li>✓ No data, no charge policy</li>
                  <li>✓ Clean room facilities available</li>
                  <li>✓ Emergency 8 X 6 recovery services</li>
                  <li>✓ Confidentiality and security guaranteed</li>
                  <li>✓ Initial evaluation is chargable</li>
                </ul>
              </div>
            </div>

            <div className="service-sidebar">
              <div className="service-card">
                <h3>Service Highlights</h3>
                <div className="highlight-item">
                  <span className="highlight-label">Success Rate:</span>
                  <span className="highlight-value">85-90%</span>
                </div>
                <div className="highlight-item">
                  <span className="highlight-label">Evaluation:</span>
                  <span className="highlight-value">Chargable</span>
                </div>
                <div className="highlight-item">
                  <span className="highlight-label">Emergency:</span>
                  <span className="highlight-value">8 X 6</span>
                </div>
                <div className="highlight-item">
                  <span className="highlight-label">Policy:</span>
                  <span className="highlight-value">No Data, No Fee</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <TalkToExpert />
    </div>
  );
};

export default DataRecovery;
